import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const BookerIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="9" cy="7" r="3" /><path d="M3 19v-1a6 6 0 0 1 12 0v1zM17 10v7M13.5 13.5h7" />
    </g>
  </SvgIcon>
)

export default BookerIcon
